var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-question"},_vm._l((_vm.data),function(q){return _c('question-item',{key:q.question_uuid,attrs:{"data":q}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }